import React, { ChangeEvent, Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { debounce } from "@formant/core/common/debounce";
import { duration } from "@formant/core/model/duration";
import { Fader } from "@formant/ui/component/common/Fader";
import { Icon } from "@formant/ui/component/common/Icon";

import { IconButton } from "./common/IconButton";
import * as styles from "./SearchField.scss";

export interface ISearchFieldProps {
    value: string;
    onChange: (value: string) => void;
    className?: string;
    placeholder?: string;
}

@observer
export class SearchField extends Component<ISearchFieldProps> {
    @observable
    private focused: boolean = false;
    @observable
    private value?: string;

    private input?: HTMLElement;

    private onChange = debounce((value: string) => {
        this.value = undefined;
        this.props.onChange(value);
    }, 0.5 * duration.second);

    public render() {
        const { className, placeholder } = this.props;

        const value = this.value !== undefined ? this.value : this.props.value;

        return (
            <div
                className={classnames(
                    styles["search-field"],
                    className,
                    this.focused && styles.focused,
                    value === "" && styles.empty,
                )}
                onClick={this.onClick}
                ref={_ => (this.input = _ || undefined)}
            >
                <Icon name="search" />
                <input
                    type="text"
                    value={value}
                    onChange={this.onChangeInput}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    placeholder={placeholder}
                    data-testid="search-field"
                />
                <Fader visible={!!value}>
                    <IconButton icon="close" onClicked={this.onClearInput} />
                </Fader>
            </div>
        );
    }

    private onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        this.value = value;
        this.onChange(value);
    };

    private onClearInput = () => {
        this.value = "";
        this.onChange("");
    };

    private onFocus = () => {
        this.focused = true;
    };

    private onBlur = () => {
        this.focused = false;
    };

    private onClick = () => {
        this.focused = true;
        if (this.input) {
            this.input.focus();
        }
    };
}
